import { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form, useFormikContext } from 'formik';
import cn from 'classnames';

import { forgotPassword } from '../../actions/auth';
import FinishPage from '../../components/StepsOld/FinishPage';
import { Input } from '../../components/FormsControls/FormControls';
import styles from './ResetPassword.module.css';

const RegisterSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
});

const SubmitButton = () => {
  const { isValid, dirty } = useFormikContext();
  return (
    <button 
      className={cn('green-button', styles.login)}
      disabled={!isValid || !dirty}
    >
      Send password
    </button>
  );
};

const defaultValues = {
  email: '',
};

const ResetPassword = (props) => {
  const { forgotPassword } = props;

  const [showMessage, setShowMessage] = useState(false);

  const registerHandler = (data, formikData) => {
    forgotPassword(data.email, formikData, () => {
      setShowMessage(true);
    });
  };

  if (showMessage) {
    return (
      <FinishPage 
        message="New password has been sent to your email"
      />
    );
  }

  return (
    <div className={styles.wrapper}>
      <Link 
        className="back-button"
        to="/login" 
      />
      <div className={styles.content}>
        <div className="medium-text">
          Forgot password
        </div>
        <Formik
          onSubmit={registerHandler}
          initialValues={defaultValues}
          validationSchema={RegisterSchema}
        >
          <Form className={styles.form}>
            <Input
              className={styles.input}
              name="email"
              type="text"
              placeholder="Enter your email"
            />
            <SubmitButton />
          </Form>
        </Formik>
      </div>
    </div>
  );
};

const mapDispatchToProps = { forgotPassword };

export default connect(null, mapDispatchToProps)(ResetPassword);
